module.exports = __webpack_public_path__ + "img/dashboardac.27eb7f2c.svg";